import { method } from '@/utils/constant'
import request from '@/utils/request'

const { POST, GET } = method

export default {
  async getMessageList(params) {
    return request({ method: POST, url: '/admin/message/admin/list', params })
  },

  async getMessageTypes(params) {
    return request({ method: POST, url: '/admin/message/admin/messageType', params })
  },

  async getMessageUserList(params) {
    return request({ method: POST, url: '/admin/message/admin/userList', params })
  },

  async getDraftCount(params) {
    return request({ method: POST, url: '/admin/message/admin/notSendNumber', params })
  },

  async getSentCount(params) {
    return request({ method: POST, url: '/admin/message/admin/sendNumber', params })
  },

  async messageOperat(params) {
    return request({ method: POST, url: '/admin/message/admin/save', params })
  },

  async messageEditOperat(params) {
    return request({ method: POST, url: '/admin/message/admin/sendMessage', params })
  },

  async organizationList() {
    return request({ method: GET, url: `/admin/background/assoUser/organizationList` })
  },

  async getUserListbyIds(params) {
    return request({ method: POST, url: `/admin/background/assoUser/getUserByOrgIds`, params })
  },

  async getMessageDetail(params) {
    return request({ method: POST, url: `/admin/message/admin/detail/${params.id}` })
  },

  async getOrgUserTree(params) {
    return request({ method: POST, url: `/admin/background/member/getOrgMemberTree` })
  },

  async feedbackList(params) {
    return request({ method: POST, url: `/admin/message/admin/feedback/list`, params })
  },

  async handleReply(params) {
    return request({ method: POST, url: `/admin/message/admin/feedback/reply`, params })
  },

  async getFeedbackDetail(params) {
    return request({ method: GET, url: `/admin/message/admin/feedback/detail/${params.id}` })
  },
}
